<template>
  <div class="main-content">
    <avue-crud
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width100 textAlignRight"
                >标题 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.title"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <!-- 新闻分类 下拉  -->
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width100 textAlignRight"
                >新闻分类 :
              </span>
              <div class="width300">
                <el-select v-model="searchData.newsClassifyId" clearable>
                  <el-option
                    v-for="item in classifyList"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width100 textAlignRight"
                >上下架 :
              </span>
              <div class="width300">
                <el-select v-model="searchData.isPublish" clearable>
                  <el-option label="上架" :value="1"></el-option>
                  <el-option label="下架" :value="2"></el-option>
                </el-select>
              </div>
            </div>
            <!-- <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width100 textAlignRight"
                >是否公开 :
              </span>
              <div class="width300">
                <el-select v-model="searchData.isPublic" clearable>
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="2"></el-option>
                </el-select>
              </div>
            </div> -->
            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="primary" @click="handleSearch"
                >搜索</el-button
              >
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="info" @click="handleReset"
                >重置</el-button
              >
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button
                size="medium"
                type="primary"
                @click="handleCreate('', 'add')"
                >新增</el-button
              >
            </div>
          </div>
        </div>
      </template>
      <template slot="image" slot-scope="{ row }">
        <el-image
          style="width: 80px; height: 80px"
          :src="row.image"
          :preview-src-list="[row.image]"
        >
        </el-image>
      </template>
      <template slot="isHome" slot-scope="{ row }">
        <el-switch
          :value="row.isHome"
          :inactive-value="2"
          :active-value="1"
          @change="handleSwitch($event, row.id)"
        ></el-switch>
      </template>
      <template slot="isPublish" slot-scope="{ row }">
        <el-switch
          :value="row.isPublish"
          :active-value="1"
          :inactive-value="2"
          @change="handlePublishSwitch($event, row.id)"
        ></el-switch>
      </template>
      <template slot="isPublic" slot-scope="{ row }">
        <el-switch
          :value="row.isPublic"
          :active-value="1"
          :inactive-value="2"
          @change="handlePublicSwitch($event, row.id)"
        ></el-switch>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="mini" @click="handleCreate(row, 'view')"
          >详情</el-button
        >
        <el-button type="text" size="mini" @click="handleCreate(row, 'edit')"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleDelete(row)"
          style="color: #ff001f !important"
          >删除</el-button
        >
      </template>
    </avue-crud>
  </div>
</template>

<script>
import {
  newsInfoList,
  newsInfoDelete,
  newsInfoHomeUpdate,
  newsInfoPublishUpdate,
  newsInfoPublicUpdate,
} from "@/api/news/info";
import { newsClassifyListAll } from "@/api/news/classify";

export default {
  name: "index",
  data() {
    return {
      classifyList: [],
      searchData: {
        title: "",
        newsClassifyId: "",
        isPublish: "",
        isPublic: "",
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableData: [], //列表数据
      showLoading: false,
      showLoadingForm: false, //防重提交
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: true, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        selection: false, // 显示多选框
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "标题",
            prop: "title",
          },
          {
            label: "图片",
            prop: "image",
          },
          {
            label: "简介",
            prop: "intro",
          },
          // 新闻分类
          {
            label: "新闻分类",
            prop: "newsClassifyName",
            type: "select",
          },
          {
            label: "首页推荐",
            prop: "isHome",
          },
          {
            label: "上下架",
            prop: "isPublish",
          },
          {
            label: "是否公开",
            prop: "isPublic",
          },
          {
            label: "更新时间",
            prop: "updateTime",
          },
        ],
      },
      dialogVisible: false,
    };
  },
  created() {
    this.getClassifyList();
  },
  methods: {
    /**
     * 初始化加载数据列表
     */
    onLoad() {
      const searchForm = {
        // path: this.$route.path,
        // searchData: this.searchData,
        ...this.searchData,
      };
      this.showLoading = true;
      newsInfoList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchForm,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          const data = res.data || {};
          this.tableData = data.records || [];
          this.page.total = data.total || 0;
        }
      });
    },

    /**
     * 点击搜索按钮查询
     */
    handleSearch() {
      this.page.currentPage = 1;
      this.onLoad();
    },

    /**
     * 点击重置按钮重置搜索条件
     */
    handleReset() {
      this.searchData = {
        title: "",
        newsClassifyId: "",
        isPublish: "",
        isPublic: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },

    /**
     * 打开新增/编辑/查看页面
     * @param {Object|string} row - 行数据对象或空字符串
     * @param {string} type - 操作类型：add / edit / view
     */
    handleCreate(row, type) {
      this.$router.push({
        path: "/news/info/create",
        query: {
          id: row ? row.id : "",
          type: type,
        },
      });
    },

    /**
     * 详情处理回调
     * @param {Object} row - 行数据对象
     */
    handleDetails(row) {
      console.log(row, "row");
    },

    /**
     * 删除新闻资讯
     * @param {Object} row - 行数据对象
     */
    handleDelete(row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        newsInfoDelete(row.id).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            this.onLoad();
          }
        });
      });
    },

    /**
     * 重置表单数据
     */
    resetForm() {
      this.form = {
        id: "",
        type: "",
      };
    },

    /**
     * 关闭弹窗
     */
    handleClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },

    /**
     * 输入框改变回调
     * @param {Event} e - 原生事件
     * @param {string} t - 目标字段名
     */
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },

    /**
     * 获取新闻分类下拉列表
     */
    getClassifyList() {
      newsClassifyListAll({ state: 1 }).then((res) => {
        if (res.code === 200) {
          this.classifyList = res.data || [];
        }
      });
    },

    /**
     * 切换首页推荐状态
     * @param {number} e - 开关状态
     * @param {string|number} id - 记录ID
     */
    handleSwitch(e, id) {
      newsInfoHomeUpdate({
        id: id,
        isHome: e,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success("操作成功");
        }
        this.onLoad();
      });
    },

    /**
     * 切换上下架状态
     * @param {number} val - 选中状态值：1-上架，2-下架
     * @param {string|number} id - 记录ID
     * @returns {void}
     */
    handlePublishSwitch(val, id) {
      newsInfoPublishUpdate({
        id: id,
        isPublish: val,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success("操作成功");
        }
        this.onLoad();
      });
    },

    /**
     * 切换是否公开状态
     * @param {number} val - 选中状态值：1-是，2-否
     * @param {string|number} id - 记录ID
     * @returns {void}
     */
    handlePublicSwitch(val, id) {
      newsInfoPublicUpdate({
        id: id,
        isPublic: val,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success("操作成功");
        }
        this.onLoad();
      });
    },
  },
};
</script>

<style scoped>
.copy {
  cursor: pointer;
  /* width: 60px; */
  margin-left: 15px;
  color: #66b1ff;
}
.tips {
  font-size: 20px;
  line-height: 1;
  margin-bottom: 30px;
}
</style>
